import type { FC } from "react";
import { Card } from "shared/components/Card";
import { cx } from "shared/utils";
import { OptionLabel } from "./slices/components/OptionLabel";
import { HugeiconsIconProps } from "@hugeicons/react";

interface CheckboxCardProps {
  className?: string;
  isChecked: boolean;
  onClick: () => void;
  disabled?: boolean;
  icon: HugeiconsIconProps["icon"];
  title: string;
  description: string;
}

export const CheckboxCard: FC<CheckboxCardProps> = ({
  icon,
  className,
  onClick,
  disabled,
  isChecked,
  title,
  description
}) => {
  const isActive = Boolean(isChecked);

  return (
    <Card
      className={cx(
        "relative bg-content-1000-inverted block rounded-lg transition-all duration-200 ease-in-out !border border-alpha-100 p-5",
        isActive ? "shadow-sm" : "shadow-xs",
        className
      )}
      onClick={() => {
        if (!disabled) onClick();
      }}
    >
      <OptionLabel
        icon={icon}
        title={title}
        description={description}
        selected={isChecked}
      />
    </Card>
  );
};
